<div [class]="badgeClass" [style.background-color]="color" [style.color]="textColor">
  {{ text | linkShort: 25 }}
</div>
